var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-510.49 -585.43) scale(5.03937)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0d0e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.207881,
      strokeLinecap: "butt",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M101.3 116.17h4.76v4.76h-4.76z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.87,
    cy: 117.47,
    cx: 102.6,
    style: {
      fill: "#37474f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.192665,
      strokeLinecap: "butt",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.87,
    cy: 117.47,
    cx: 104.76,
    style: {
      fill: "#37474f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.192665,
      strokeLinecap: "butt",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.87,
    cy: 119.63,
    cx: 102.6,
    style: {
      fill: "#37474f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.192665,
      strokeLinecap: "butt",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.87,
    cy: 119.63,
    cx: 104.76,
    style: {
      fill: "#37474f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.192665,
      strokeLinecap: "butt",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandIcon);
export default __webpack_public_path__ + "static/media/stand-icon.b9d0bf9687950f82a05d6dffa25c02e3.svg";
export { ForwardRef as ReactComponent };